import { ICountryItem } from '@reolink-cloud/interface';
import { config } from 'CONFIG';
import i18n from 'LANG';
import { httpManager as http } from '@/plugins/HttpManager';

const timeStamp = process.env.TIME_STAMP;

export const getDeviceSupport = (): Promise<any> => {

    return new Promise(( resolve, reject ) => {

        $.get( `https://home-cdn.reolink.us/wp-content/uploads/2018/public/cloud-support.json?sv=${timeStamp!}` ).then( res => {

            resolve( res );

        }).fail( err => {

            reject( err );

        });

    });

};

export async function getCountryList(): Promise<ICountryItem[]> {

    const { data } = await http.get<ICountryItem[]>( '/countries.json', { baseURL: location.origin });
    
    return data;

}

export const listToString = ( arr: string[], lang?: string ): string => {

    const and = i18n.t( 'common.and' );
    const _arr = arr.slice( 0 );

    if ( _arr.length === 0 ) {

        return '';

    }
    if ( _arr.length > 1 ) {

        _arr[ _arr.length - 1 ] = `${and as string} ${_arr[ _arr.length - 1 ]}`;

    }
    if ( lang === 'de' ) {

        const last = _arr.splice( -1, 1 );
        return _arr.length >= 1 ? _arr.join( ', ' ) + ' ' + last[0] : last[0];

    }
    return _arr.join( ', ' );

};
